/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RankingQueryResultMcStats model module.
 * @module model/RankingQueryResultMcStats
 * @version 1.0
 */
class RankingQueryResultMcStats {
    /**
     * Constructs a new <code>RankingQueryResultMcStats</code>.
     * @alias module:model/RankingQueryResultMcStats
     */
    constructor() { 
        
        RankingQueryResultMcStats.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RankingQueryResultMcStats</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RankingQueryResultMcStats} obj Optional instance to populate.
     * @return {module:model/RankingQueryResultMcStats} The populated <code>RankingQueryResultMcStats</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RankingQueryResultMcStats();

            if (data.hasOwnProperty('answeredSum')) {
                obj['answeredSum'] = ApiClient.convertToType(data['answeredSum'], 'Number');
            }
            if (data.hasOwnProperty('calculatedAt')) {
                obj['calculatedAt'] = ApiClient.convertToType(data['calculatedAt'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('earnedSum')) {
                obj['earnedSum'] = ApiClient.convertToType(data['earnedSum'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} answeredSum
 */
RankingQueryResultMcStats.prototype['answeredSum'] = undefined;

/**
 * @member {String} calculatedAt
 */
RankingQueryResultMcStats.prototype['calculatedAt'] = undefined;

/**
 * @member {String} date
 */
RankingQueryResultMcStats.prototype['date'] = undefined;

/**
 * @member {Number} earnedSum
 */
RankingQueryResultMcStats.prototype['earnedSum'] = undefined;

/**
 * @member {Number} userId
 */
RankingQueryResultMcStats.prototype['userId'] = undefined;






export default RankingQueryResultMcStats;

